var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.subject)?_c('div',{staticClass:"row-box"},[_c('Subject',{attrs:{"subject":_vm.subject,"statement":_vm.statement}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }